module.exports = __webpack_public_path__ + "img/mclogi-mobile2.8c42299.png";